import LoginPage from "./Components/layouts/Login";
import {Route, Routes, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import OtpVerification from "./Components/layouts/OTPVerification";
import Sidebar from "./Components/layouts/Sidebar";
import AppRoutes from "./routes/AppRoutes";
import PageHeader from "./Components/Comman/PageHeader";
import { useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./store/authSlice";
import { connectWebSocket } from "./store/webSlice";
import { ADMIN, PROJECT_COORDINATOR } from "./constants/roles";
import { useNotifyCount } from "./store/Notifycount";
import './index.css'
import { useChatNotifyCount } from "./store/ChatNotifyCount";
function App() {
  const user = useSelector((state) => state?.auth?.user);
  const token=useSelector((state)=>state?.auth?.accessToken);
  const { increaseNotifyCount } = useNotifyCount();
  const { increaseChatNotifyCount } = useChatNotifyCount();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  

  useEffect(() => {
    if (!user) {
      navigate("/login");
    } else {
      const isSession=sessionStorage.getItem('header');
      if(user && !isSession){
           dispatch(setUser({ user, accessToken: user.token }));
           if(user.role === ADMIN){
            sessionStorage.setItem('header','Dashboard')
            navigate('/admin/dashboard')
           }
           else if(user.role === PROJECT_COORDINATOR){
            sessionStorage.setItem('header','Dashboard')
            navigate("/project-coordinator/dashboard");
           }else{
              sessionStorage.setItem('header','Dashboard')
              navigate("/client/dashboard");
           }
       }else{
        dispatch(setUser({ user, accessToken: user.token }));
       }
    }
  }, [user]);

  useEffect(() => {
  if (token) {
    dispatch(connectWebSocket({token,increaseNotifyCount,increaseChatNotifyCount}));
  }
}, [token]);  

  return (
    <>
      {!user ? (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/verify-otp" element={<OtpVerification />} />
        </Routes>
      ) : (
        <div className="w-full h-screen flex bg-gradient-to-b from-emerald-50  to-orange-50">
          <div className="lg:w-[17%] xl:w-[13%] " >
            <Sidebar />
          </div>
          <div
            className="w-full lg:w-[83] xl:w-[87%] overflow-y-auto min-h-screen h-auto relative" 
            style={{ scrollbarWidth: "none" }}>
            <PageHeader />
            <AppRoutes />
          </div> 
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
